import { createNavigationContainerRef } from "@react-navigation/native";
import { RootStackParamList } from "./routes";

export default createNavigationContainerRef<RootStackParamList>();
